export const NUBANK_EXPERIENCE_SESSION_KEY = 'nubank_experience';

export const NUBANK_UTM_MEDIUM = 'nubank';
export const NUBANK_CAMPAIGN_NUSCORE = 'nuscore';
export const NUBANK_CAMPAIGN_LP = 'lp';
export const NUBANK_CAMPAIGN_EMAIL = 'email';
export const NUBANK_CAMPAIGN_DESENROLA = 'desenrola';
